import { createStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import { Theme, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import CheckIcon from "@material-ui/icons/CheckCircle";
import SaveIcon from "@material-ui/icons/Save";
import classNames from "classnames";
import * as React from "react";
import * as settingsService from "../services/settings";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2
    },
    paper: {
      width: "50%",
      margin: "auto"
    },
    leftIcon: {
      marginRight: theme.spacing.unit
    },
    iconSmall: {
      fontSize: 20
    },
    button: {
      margin: theme.spacing.unit
    }
  });

interface ISettings {
  id: string;
}

class Settings extends React.Component<any, any> {
  constructor(props: unknown) {
    super(props);

    this.state = { id: "", confirmationVisible: false };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  public handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    switch (event.target.id) {
      case "deviceId":
        this.setState({ id: event.target.value });
    }
  }

  public async handleSave(event: any) {
    if (this.state.id) {
      const response = await fetch(`/api/v1/device/${this.state.id}`);

      if (!response.ok) {
        throw Error(`Could not get device settings for ${this.state.id}.`);
      }

      const device = await response.json();

      settingsService.saveSettings({
        id: device.id,
        os: device.os,
        currency: device.currency,
        clientId: device.squareupSettings.clientId,
        kioskUrl: device.kioskUrl
      });
    }

    this.setState({ confirmationVisible: true });
  }

  public componentDidMount = () => {
    const settings = settingsService.getSettings();
    if (settings) {
      this.setState({ ...settings });
    }
  };

  public render() {
    return (
      <div>
        <Paper
          className={classNames(
            this.props.classes.paper,
            this.props.classes.root
          )}
        >
          <Typography variant="title" gutterBottom={true}>
            Device Configuration
          </Typography>
          <Grid container={true} spacing={24}>
            <Grid item={true} xs={12} sm={6}>
              <TextField
                required={true}
                id="deviceId"
                name="deviceId"
                label="Device ID"
                fullWidth={true}
                autoComplete="off"
                value={this.state.id}
                onChange={this.handleChange}
              />
            </Grid>
            <Grid item={true}>
              <Button
                variant="contained"
                size="small"
                className={this.props.classes.button}
                onClick={this.handleSave}
              >
                <SaveIcon
                  className={classNames(
                    this.props.classes.leftIcon,
                    this.props.classes.iconSmall
                  )}
                />
                Save
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.confirmationVisible}
          autoHideDuration={6000}
          onClose={() => this.setState({ confirmationVisible: false })}
          message={
            <span>Device ID {this.state.id ? "saved" : "cleared"}.</span>
          }
          action={<CheckIcon />}
        />
      </div>
    );
  }
}

export default withStyles(styles)(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings.tsx